import { fetchUserAttributes, updateUserAttributes } from 'aws-amplify/auth';

const ATTR = 'custom:notifyLevel';

export const NOTIFY = {
  NONE: 'none',
  DAILY: 'daily',
  // REALTIME: 'realtime', // reserved for "on every map refresh" (future)
};

export async function getNotifyLevel() {
  try {
    const attrs = await fetchUserAttributes();
    return attrs?.[ATTR] || NOTIFY.NONE;
  } catch {
    return NOTIFY.NONE;
  }
}

export async function setNotifyLevel(level) {
  await updateUserAttributes({ userAttributes: { [ATTR]: level } });
}
